import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ESVRStatus } from '@services/cleanfill-api/cleanfill-api.generated';

@Component({
  selector: 'app-esvr-dispute',
  templateUrl: './esvr-dispute.component.html',
  styleUrls: ['./esvr-dispute.component.scss']
})
export class EsvrDisputeComponent implements OnInit {
  @Output() rejectESVR = new EventEmitter<string>();
  @Output() holdESVR = new EventEmitter<string>();
  @Output() closeMenu = new EventEmitter<void>();
  @Input() status: ESVRStatus;
  ESVRStatus = ESVRStatus;
  rejectionReason = new FormControl('', [Validators.required, Validators.maxLength(500)]);
  constructor() {}
  ngOnInit() {}
  close() {
    this.closeMenu.emit();
  }

  reject(): void {
    this.rejectESVR.emit(this.rejectionReason.value);
  }
  onHold(): void {
    this.holdESVR.emit(this.rejectionReason.value);
  }
}
